import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import SMSModal from '../monitoring/SMSModal';
import ContactPrefs from "../monitoring/ContactPrefs";
import AlertPrefStatusModal from '../monitoring/AlertPrefStatusModal';

const MODAL_COMPONENTS = {
  ALERT_PREF_MODAL: ContactPrefs,
  SMS_MODAL: SMSModal,
  MA_ALERT_PREF_STATUS_MODAL: AlertPrefStatusModal
};

const ModalRoot = ({modalType, modalProps}) => {
  if (!modalType) {
    return null
  }
  const SpecificModal = MODAL_COMPONENTS[modalType];
  return <SpecificModal {...modalProps} />
};

ModalRoot.propTypes = {
  modalType: PropTypes.string,
  modalProps: PropTypes.object
};

export default connect(
  state => state.modal
)(ModalRoot);



// WEBPACK FOOTER //
// ./src/containers/common/ModalRoot.js